var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product_item"
  }, [_c("a", {
    staticClass: "link"
  }, [_c("div", {
    staticClass: "productImg"
  }, [_c("YYImage", {
    staticClass: "yyImg",
    attrs: {
      src: _vm.productDetail.host + _vm.productDetail.productImage
    }
  }), _vm.productDetail.productStatus == 0 || _vm.productDetail.productStatus == 2 ? _c("div", {
    staticClass: "stockout"
  }, [_vm._v(_vm._s(_vm.$t("offShelves")))]) : _vm.productDetail.productStockNum <= 0 ? _c("div", {
    staticClass: "stockout"
  }, [_vm._v(_vm._s(_vm.$t("stockout")))]) : _vm._e()], 1), _c("div", {
    staticClass: "price"
  }, [_vm.productDetail.productDiscountPrice == _vm.productDetail.productOriginalPrice ? [_c("span", {
    domProps: {
      innerHTML: _vm._s(_vm.$checkPrice(_vm.productDetail.productOriginalPrice))
    }
  })] : _vm._e(), _vm.productDetail.productDiscountPrice != _vm.productDetail.productOriginalPrice ? [_c("span", {
    staticClass: "discount_before"
  }, [_c("span", {
    domProps: {
      innerHTML: _vm._s(_vm.$checkPrice(_vm.productDetail.productOriginalPrice))
    }
  }), _vm._m(0)]), _c("span", {
    staticClass: "discount_after"
  }, [_c("span", {
    domProps: {
      innerHTML: _vm._s(_vm.$checkPrice(_vm.productDetail.productDiscountPrice))
    }
  })])] : _vm._e()], 2), _c("div", {
    staticStyle: {
      height: "58px"
    }
  }, [_c("div", {
    staticClass: "name",
    attrs: {
      title: _vm.productDetail.productName
    }
  }, [_vm.productDetail.bundle === 1 ? _c("span", {
    staticClass: "bundling_tag"
  }, [_vm._v(_vm._s(_vm.$t("bunding")))]) : _vm._e(), _vm._v(_vm._s(_vm.productDetail.productName))]), _c("div", {
    staticClass: "specs"
  }, [_vm._v(_vm._s(_vm.productDetail.productSpecification))])]), _c("div", {
    staticClass: "tags"
  }, [_vm.productDetail.productOnlineTag ? _c("span", [_vm._v(_vm._s(_vm.productDetail.productOnlineTag))]) : _vm._e(), _vm.productDetail.bargainStatus == 1 ? _c("span", [_vm._v(_vm._s(_vm.$t("sellOff")))]) : _vm._e(), _vm.productDetail.productStockNumTag ? _c("span", [_vm._v(_vm._s(_vm.productDetail.productStockNumTag))]) : _vm._e(), _vm.productDetail.productChannelTag ? _c("span", [_vm._v(_vm._s(_vm.productDetail.productChannelTag))]) : _vm._e()]), _vm.productDetail.activityType || _vm.productDetail.couponTypeList && _vm.productDetail.couponTypeList.length > 0 ? _c("div", {
    staticClass: "activity"
  }, [_vm.productDetail.activityType == 1 ? _c("YYTag", {
    attrs: {
      effect: "plain",
      type: "danger",
      size: "mini"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("verticalReductionActivity")) + " ")]) : _vm._e(), _vm.productDetail.activityType == 2 ? _c("YYTag", {
    attrs: {
      effect: "plain",
      type: "danger",
      size: "mini"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("discountActivity")) + " ")]) : _vm._e(), _vm._l(_vm.productDetail.couponTypeList, function (item) {
    return _c("span", {
      staticClass: "couponTag"
    }, [item == 1 ? _c("YYTag", {
      attrs: {
        effect: "plain",
        size: "mini"
      }
    }, [_vm._v(_vm._s(_vm.$t("verticalReductionActivityCoupon")))]) : _vm._e(), item == 2 ? _c("YYTag", {
      attrs: {
        effect: "plain",
        size: "mini"
      }
    }, [_vm._v(_vm._s(_vm.$t("discountActivityCoupon")))]) : _vm._e(), item == 3 ? _c("YYTag", {
      attrs: {
        effect: "plain",
        size: "mini"
      }
    }, [_vm._v(_vm._s(_vm.$t("freeShippingyCoupon")))]) : _vm._e()], 1);
  })], 2) : _c("div", {
    staticStyle: {
      height: "31px",
      width: "100%"
    }
  }), _vm.type == "collect" ? _c("div", {
    staticClass: "btn",
    style: "background-color:" + _vm.addCartBgColor
  }, [_c("div", {
    staticStyle: {
      display: "flex"
    }
  }, [_vm.showShadow ? _c("div", {
    staticClass: "stockoutShade"
  }) : _vm._e(), _c("YYButton", {
    staticStyle: {
      flex: "1"
    },
    attrs: {
      size: "small",
      disabled: _vm.submitLock,
      type: "primary"
    },
    on: {
      click: function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addCart(_vm.productDetail.productNo);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("addShoppingCart")))]), _c("YYButton", {
    staticStyle: {
      flex: "1",
      "z-index": "1001"
    },
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.deleteCollect(_vm.productDetail.productSpecificationId);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("myCollect.cancelCollect")))])], 1)]) : _c("div", {
    staticClass: "btn",
    style: "background-color:" + _vm.addCartBgColor
  }, [_vm.showShadow ? _c("div", {
    staticClass: "stockoutShade"
  }) : _vm._e(), _c("YYButton", {
    attrs: {
      disabled: _vm.submitLock,
      type: "primary"
    },
    on: {
      click: function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addCart(_vm.productDetail.productNo);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("addShoppingCart")))])], 1), _vm.productDetail.productPointNum > 1 && _vm.productDetail.productStatus == 1 ? _c("div", {
    staticClass: "pointTab"
  }, [_c("div", {
    staticClass: "tabLeft"
  }), _c("div", {
    staticClass: "tabMiddle"
  }, [_vm._v(_vm._s(_vm.$t("pointNumber", {
    productPointNum: _vm.productDetail.productPointNum
  })))]), _c("div", {
    staticClass: "tabRight"
  })]) : _vm._e(), _vm.productDetail.transportName ? _c("div", {
    staticClass: "transportNameTab"
  }, [_vm._v(_vm._s(_vm.productDetail.transportName) + " ")]) : _vm._e(), _vm.showShadow ? _c("div", {
    staticClass: "stockoutShade"
  }) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "unit"
  }, [_c("span", {
    staticStyle: {
      padding: "0 8px"
    }
  }, [_vm._v("→")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };